import { render, staticRenderFns } from "./BadgeColor.vue?vue&type=template&id=10afdb16&scoped=true&lang=pug&"
import script from "./BadgeColor.vue?vue&type=script&lang=js&"
export * from "./BadgeColor.vue?vue&type=script&lang=js&"
import style0 from "./BadgeColor.vue?vue&type=style&index=0&id=10afdb16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10afdb16",
  null
  
)

export default component.exports